// extracted by mini-css-extract-plugin
export default {"invalid-error":"PolicyholderForm_invalid-error__7cVE5"};